import { useState, useCallback } from "react";

interface UseQuantityReturn {
  quantity: number;
  setQuantity: (value: number) => void;
  increase: () => void;
  decrease: () => void;
}

export const useQuantity = (maxQuantity: number = 12, minQuantity: number = 1): UseQuantityReturn => {
  const [quantity, setQuantityState] = useState<number>(minQuantity);

  const setQuantity = useCallback((value: number) => {
    setQuantityState((prev) => {
      if (value >= minQuantity && value <= maxQuantity) {
        return value;
      }
      return prev;
    });
  }, [minQuantity, maxQuantity]);

  const increase = useCallback(() => {
    setQuantityState((prev) => (prev < maxQuantity ? prev + 1 : prev));
  }, [maxQuantity]);

  const decrease = useCallback(() => {
    setQuantityState((prev) => (prev > minQuantity ? prev - 1 : prev));
  }, [minQuantity]);

  return { quantity, setQuantity, increase, decrease };
};

